import { z } from 'zod';
import superjson from 'superjson';
import { UserRole } from '../../helpers/schema';

export const schema = z.object({});

export type InputType = z.infer<typeof schema>;

export type OutputType = {
  id: number;
  email: string;
  displayName: string;
  avatarUrl: string | null;
  role: UserRole;
  createdAt: Date;
};

export const getUserProfile = async (init?: RequestInit): Promise<OutputType> => {
  const result = await fetch(`/_api/user/profile`, {
    method: 'GET',
    credentials: 'include',
    ...init,
    headers: {
      'Content-Type': 'application/json',
      ...(init?.headers ?? {}),
    },
  });

  if (!result.ok) {
    const errorObject = superjson.parse<{ error: string }>(await result.text());
    throw new Error(errorObject.error);
  }
  return superjson.parse<OutputType>(await result.text());
};
